/**
 * Les dates en clair de la console, a l'heure du navigateur : l'heure d'une saisie, l'ecart
 * depuis une ecriture, le jour d'une ligne de journal. Nees avec les Histoires (#226), communes
 * depuis que les livres-jeux (#276) s'en servent : un module n'importe jamais un autre module.
 * Aucune horloge implicite : l'instant courant est passe en argument.
 */

const MS_PAR_JOUR = 86_400_000;

function deuxChiffres(nombre: number): string {
  return String(nombre).padStart(2, "0");
}

/** Le numero du jour civil, a l'heure du navigateur (un changement d'heure ne le decale pas). */
function jourCivil(date: Date): number {
  return Math.round(
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / MS_PAR_JOUR,
  );
}

/** « 21:48 », a l'heure du navigateur. */
export function heure(instant: string | number): string {
  const date = new Date(instant);
  return `${deuxChiffres(date.getHours())}:${deuxChiffres(date.getMinutes())}`;
}

/**
 * Une ligne du journal : « aujourd'hui 21:48 », « hier 22:10 », sinon « 26/09 22:10 ». Une date
 * illisible est rendue telle quelle.
 */
export function quandEnClair(instant: string, maintenant: number): string {
  const date = new Date(instant);
  if (Number.isNaN(date.getTime())) return instant;
  const ecart = jourCivil(new Date(maintenant)) - jourCivil(date);
  if (ecart === 0) return `aujourd'hui ${heure(instant)}`;
  if (ecart === 1) return `hier ${heure(instant)}`;
  return `${deuxChiffres(date.getDate())}/${deuxChiffres(date.getMonth() + 1)} ${heure(instant)}`;
}

/** L'heure d'une saisie gardee sur l'appareil : « de 21:40 » le jour meme, « du 26/09 à 21:40 » sinon. */
export function saisieDe(instant: string, maintenant: number): string {
  const date = new Date(instant);
  if (Number.isNaN(date.getTime())) return "d'avant";
  if (jourCivil(new Date(maintenant)) === jourCivil(date)) return `de ${heure(instant)}`;
  return `du ${deuxChiffres(date.getDate())}/${deuxChiffres(date.getMonth() + 1)} à ${heure(instant)}`;
}

/** « il y a 4 s », « il y a 3 min », « il y a 2 h » ; « à l'instant » sous une seconde. */
export function ilYA(ms: number): string {
  const secondes = Math.floor(Math.max(0, ms) / 1000);
  if (secondes < 1) return "à l'instant";
  if (secondes < 60) return `il y a ${secondes} s`;
  const minutes = Math.floor(secondes / 60);
  if (minutes < 60) return `il y a ${minutes} min`;
  return `il y a ${Math.floor(minutes / 60)} h`;
}

/** « Modifié » sur l'accueil : l'ecart en clair jusqu'a un jour, la date ensuite. */
export function modifieEnClair(instant: string, maintenant: number): string {
  const date = new Date(instant);
  if (Number.isNaN(date.getTime())) return "";
  const ecart = maintenant - date.getTime();
  if (ecart < MS_PAR_JOUR) return ilYA(ecart);
  return `le ${deuxChiffres(date.getDate())}/${deuxChiffres(date.getMonth() + 1)}/${date.getFullYear()}`;
}
